/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getProduct = /* GraphQL */ `
  query GetProduct($id: ID!) {
    getProduct(id: $id) {
      id
      code
      description
      cost
      price
      createdAt
      updatedAt
    }
  }
`;
export const listProducts = /* GraphQL */ `
  query ListProducts(
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        code
        description
        cost
        price
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getPharmacy = /* GraphQL */ `
  query GetPharmacy($id: ID!) {
    getPharmacy(id: $id) {
      id
      code
      description
      enabled
      createdAt
      updatedAt
    }
  }
`;
export const listPharmacys = /* GraphQL */ `
  query ListPharmacys(
    $filter: ModelPharmacyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPharmacys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        code
        description
        enabled
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCustomer = /* GraphQL */ `
  query GetCustomer($id: ID!) {
    getCustomer(id: $id) {
      id
      customerId
      name
      contactName
      chargeTo
      createdAt
      updatedAt
    }
  }
`;
export const listCustomers = /* GraphQL */ `
  query ListCustomers(
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        customerId
        name
        contactName
        chargeTo
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getContract = /* GraphQL */ `
  query GetContract($id: ID!) {
    getContract(id: $id) {
      id
      voucherCode
      voucherExpiry
      customerId
      productId
      customer {
        id
        customerId
        name
        contactName
        chargeTo
        createdAt
        updatedAt
      }
      product {
        id
        code
        description
        cost
        price
        createdAt
        updatedAt
      }
      customerAttributes {
        name
        multiList
      }
      createdAt
      updatedAt
    }
  }
`;
export const listContracts = /* GraphQL */ `
  query ListContracts(
    $filter: ModelContractFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listContracts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        voucherCode
        voucherExpiry
        customerId
        productId
        customer {
          id
          customerId
          name
          contactName
          chargeTo
          createdAt
          updatedAt
        }
        product {
          id
          code
          description
          cost
          price
          createdAt
          updatedAt
        }
        customerAttributes {
          name
          multiList
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getAdditionalItem = /* GraphQL */ `
  query GetAdditionalItem($id: ID!) {
    getAdditionalItem(id: $id) {
      id
      contractId
      label
      values
      createdAt
      updatedAt
    }
  }
`;
export const listAdditionalItems = /* GraphQL */ `
  query ListAdditionalItems(
    $filter: ModelAdditionalItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAdditionalItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        contractId
        label
        values
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getVaccination = /* GraphQL */ `
  query GetVaccination($id: ID!) {
    getVaccination(id: $id) {
      id
      pharmacyCode
      chargeTo
      voucherCode
      contractId
      contract {
        id
        voucherCode
        voucherExpiry
        customerId
        productId
        customer {
          id
          customerId
          name
          contactName
          chargeTo
          createdAt
          updatedAt
        }
        product {
          id
          code
          description
          cost
          price
          createdAt
          updatedAt
        }
        customerAttributes {
          name
          multiList
        }
        createdAt
        updatedAt
      }
      vaccinationDate
      patientName
      customerAttributes {
        name
        value
      }
      lastUpdatedBy
      vaccinationYearMonth
      createdAt
      updatedAt
    }
  }
`;
export const listVaccinations = /* GraphQL */ `
  query ListVaccinations(
    $filter: ModelVaccinationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVaccinations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        pharmacyCode
        chargeTo
        voucherCode
        contractId
        contract {
          id
          voucherCode
          voucherExpiry
          customerId
          customer {
                chargeTo
                 name
                 }
          productId
          createdAt
          updatedAt
        }
        vaccinationDate
        patientName
        customerAttributes {
          name
          value
        }
        lastUpdatedBy
        vaccinationYearMonth
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getPharmacyUser = /* GraphQL */ `
  query GetPharmacyUser($id: ID!) {
    getPharmacyUser(id: $id) {
      id
      userEmail
      pharmacyCodes
      enabled
      createdAt
      updatedAt
    }
  }
`;
export const listPharmacyUsers = /* GraphQL */ `
  query ListPharmacyUsers(
    $filter: ModelPharmacyUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPharmacyUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userEmail
        pharmacyCodes
        enabled
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getProductByCode = /* GraphQL */ `
  query GetProductByCode(
    $code: String
    $sortDirection: ModelSortDirection
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getProductByCode(
      code: $code
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        code
        description
        cost
        price
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getPharmacyByCode = /* GraphQL */ `
  query GetPharmacyByCode(
    $code: String
    $sortDirection: ModelSortDirection
    $filter: ModelPharmacyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getPharmacyByCode(
      code: $code
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        code
        description
        enabled
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCustomerById = /* GraphQL */ `
  query GetCustomerById(
    $customerId: String
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getCustomerById(
      customerId: $customerId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerId
        name
        contactName
        chargeTo
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getVoucherCode = /* GraphQL */ `
  query GetVoucherCode(
    $voucherCode: String
    $sortDirection: ModelSortDirection
    $filter: ModelContractFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getVoucherCode(
      voucherCode: $voucherCode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        voucherCode
        voucherExpiry
        customerId
        productId
        customer {
          id
          customerId
          name
          contactName
          chargeTo
          createdAt
          updatedAt
        }
        product {
          id
          code
          description
          cost
          price
          createdAt
          updatedAt
        }
        customerAttributes {
          name
          multiList
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const additionalItemByContractId = /* GraphQL */ `
  query AdditionalItemByContractId(
    $contractId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelAdditionalItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    additionalItemByContractId(
      contractId: $contractId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        contractId
        label
        values
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getVaccinationsByPharmacy = /* GraphQL */ `
  query GetVaccinationsByPharmacy(
    $pharmacyCode: String
    $sortDirection: ModelSortDirection
    $filter: ModelVaccinationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getVaccinationsByPharmacy(
      pharmacyCode: $pharmacyCode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        pharmacyCode
        chargeTo
        voucherCode
        contractId
        contract {
          id
          voucherCode
          voucherExpiry
          customerId
          productId
          createdAt
          updatedAt
        }
        vaccinationDate
        patientName
        customerAttributes {
          name
          value
        }
        lastUpdatedBy
        vaccinationYearMonth
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getVaccinationsByChargeTo = /* GraphQL */ `
  query GetVaccinationsByChargeTo(
    $chargeTo: String
    $sortDirection: ModelSortDirection
    $filter: ModelVaccinationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getVaccinationsByChargeTo(
      chargeTo: $chargeTo
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        pharmacyCode
        chargeTo
        voucherCode
        contractId
        contract {
          id
          voucherCode
          voucherExpiry
          customerId
          productId
          createdAt
          updatedAt
        }
        vaccinationDate
        patientName
        customerAttributes {
          name
          value
        }
        lastUpdatedBy
        vaccinationYearMonth
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getVaccinationsByVoucherCodeAndPatient = /* GraphQL */ `
  query GetVaccinationsByVoucherCodeAndPatient(
    $voucherCode: String
    $patientName: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVaccinationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getVaccinationsByVoucherCodeAndPatient(
      voucherCode: $voucherCode
      patientName: $patientName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        pharmacyCode
        chargeTo
        voucherCode
        contractId
        contract {
          id
          voucherCode
          voucherExpiry
          customerId
          productId
          createdAt
          updatedAt
        }
        vaccinationDate
        patientName
        customerAttributes {
          name
          value
        }
        lastUpdatedBy
        vaccinationYearMonth
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getVaccinationsByVaccinationYearMonth = /* GraphQL */ `
  query GetVaccinationsByVaccinationYearMonth(
    $vaccinationYearMonth: String
    $sortDirection: ModelSortDirection
    $filter: ModelVaccinationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getVaccinationsByVaccinationYearMonth(
      vaccinationYearMonth: $vaccinationYearMonth
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        pharmacyCode
        chargeTo
        voucherCode
        contractId
        contract {
          id
          voucherCode
          voucherExpiry
          customerId
          productId
          createdAt
          updatedAt
        }
        vaccinationDate
        patientName
        customerAttributes {
          name
          value
        }
        lastUpdatedBy
        vaccinationYearMonth
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getPharmacyUserByUserEmail = /* GraphQL */ `
  query GetPharmacyUserByUserEmail(
    $userEmail: String
    $sortDirection: ModelSortDirection
    $filter: ModelPharmacyUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getPharmacyUserByUserEmail(
      userEmail: $userEmail
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userEmail
        pharmacyCodes
        enabled
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
